import { colors } from './colors';
import { desktop } from './media-queries';
const baseFontXpx = (add = 0) => `${14 + add}px`;
const baseLineHeightXpx = (add = 0) => `${22 + add}px`;
const font = (family) => `
  font-stretch:100%;
  font-style:normal;
  font-variant-caps:normal;
  font-variant-east-asian:normal;
  font-variant-ligatures:normal;
  font-variant-numeric:normal;
  font-weight:400;
  text-align: start;
  font-family: ${family}, sans-serif;
`;
export const bodyStyle = `
  color: ${colors.grey.grey80};
`;
export const normalStyle = `
  ${font('Open Sans')}
  color: inherit;
  font-size: ${baseFontXpx()};
  line-height: ${baseLineHeightXpx()};
  ${desktop(`
     font-size: ${baseFontXpx(2)}; 
     line-height: ${baseLineHeightXpx(2)}; 
  `)};

`;
export const h1Style = `
  ${font('"SignaWeb-Light"')}
  color: inherit;
  font-size: ${baseFontXpx(10)};
  line-height: ${baseLineHeightXpx(8)};
  ${desktop(`
    font-size: ${baseFontXpx(16)};
    line-height: ${baseLineHeightXpx(22)};
  `)};
`;
export const h2Style = `
  ${font('"SignaWeb-Light"')}
  color: inherit;
  font-size: ${baseFontXpx(6)};
  line-height: ${baseLineHeightXpx(6)};
  ${desktop(`
     font-size: ${baseFontXpx(12)};
    line-height: ${baseLineHeightXpx(16)};
  `)};
`;
export const h3Style = `
  ${font('Open Sans Bold')}
  color: inherit;
  font-size: ${baseFontXpx(2)};
  line-height: ${baseLineHeightXpx(2)};
  font-weight:700;
  ${desktop(`
    font-size: ${baseFontXpx(4)};
    line-height: ${baseLineHeightXpx(4)};
  `)};
`;
export const subtitleStyle = `
  ${font('Open Sans')}
  color: inherit;
  font-size: ${baseFontXpx(2)};
  line-height: ${baseLineHeightXpx(2)};
  ${desktop(`
    font-size: ${baseFontXpx(4)};
    line-height: ${baseLineHeightXpx(4)}
  `)};
`;
export const pStyle = normalStyle;
export const spanStyle = normalStyle;
export const formLabelStyle = `
  ${font('Open Sans Semibold')}
  color: inherit;
  font-size: ${baseFontXpx()};
  font-weight:600;
  line-height: ${baseLineHeightXpx()};
  ${desktop(`
    font-size: ${baseFontXpx(2)};
    line-height: ${baseLineHeightXpx(2)}; `)};

`;
export const formInputStyle = `
  ${font('Open Sans')}
  color: inherit;
  font-size:  ${baseFontXpx()};
  line-height: ${baseLineHeightXpx(2)};
  ${desktop(`
     font-size: ${baseFontXpx(2)}; 
     line-height: ${baseLineHeightXpx(2)}; `)};
`;
export const formHintStyle = `
  ${font('Open Sans')}
  color: inherit;
  font-size: ${baseFontXpx(-2)};
  line-height: ${baseLineHeightXpx(-4)}
  ${desktop(`
     font-size: ${baseFontXpx()}; 
     line-height: ${baseLineHeightXpx()}; `)};

`;
export const formErrorStyle = `
  ${font('Open Sans')}
  color: ${colors.red.red60};
  font-size: ${baseFontXpx(-2)};
  line-height: ${baseLineHeightXpx(-4)};
  ${desktop(`
     font-size: ${baseFontXpx()}; 
     ine-heigth: ${baseLineHeightXpx()}; `)};

`;
export const CAPS_HEADING_STYLE = `
  ${font('Open Sans')}
  color: inherit;
  font-size: ${baseFontXpx()};
  line-height: ${baseLineHeightXpx()};
  text-transform: uppercase;
  ${desktop(`
     font-size:  ${baseFontXpx()};
    line-height: ${baseLineHeightXpx()}; `)};

`;
export const BOLD_CAPS_HEADING_STYLE = `
  ${font('Open Sans Bold')}
  color: inherit;
  font-size: ${baseFontXpx()};
  line-height: ${baseLineHeightXpx()};
  font-weight:700;
  text-transform: uppercase;
  ${desktop(`
    line-height: ${baseLineHeightXpx()}; `)};
`;
